import React, { useState } from 'react';

import { func, shape, string, number } from 'prop-types';

import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';

import Button from 'components/Common/Buttons/ButtonV3';
import Checkbox from 'components/Common/Checkbox';
import Flexbox from 'components/Common/Flexbox';
import Text from 'components/Common/Text';

import { ensureArray } from 'utils/arrays';

import s from './MultiSelectInput.css';

const MultiSelectInput = ({
  contextId,
  handleDeleteResponse,
  handleSaveResponse,
  initialValue,
  prompt,
  responseId,
  setManualClose,
}) => {
  const [response, setResponse] = useState(ensureArray(initialValue));

  const handleUpdateResponse = value => {
    if (response.includes(value)) {
      const updatedResponses = response.filter(val => value !== val);
      setResponse(updatedResponses);
      return;
    }

    setResponse(prev => [...prev, value]);
  };

  const handleDelete = async () => {
    setResponse([]);
    await handleDeleteResponse({ promptId: prompt.id, contextId, responseId });
  };

  return (
    <>
      <Text variant="titleMdBold" mb={0.25}>
        {prompt.text}
      </Text>
      <Text color="grayDark" variant="meta" mb={1.5}>
        Select one or more options
      </Text>
      <List className={s.list}>
        {prompt.options.map(opt => (
          <ListItemButton
            selected={initialValue === opt.id}
            key={opt.id}
            className={s.listItem}
            onClick={() => handleUpdateResponse(opt.id)}
          >
            <Checkbox
              removeOffset
              value={opt.id}
              checked={response.includes(opt.id)}
            />
            <Text>{opt.value}</Text>
          </ListItemButton>
        ))}
        <ListItemButton onClick={handleDelete}>Clear</ListItemButton>
      </List>
      <Flexbox justifyContent="flex-end" gap={2} mt={1.5}>
        <Button
          color="gray"
          label="Cancel"
          onClick={e => {
            e.stopPropagation();
            setManualClose(true);
          }}
          size="small"
          variant="text"
        />
        <Button
          label="Save"
          size="small"
          onClick={e => {
            e.stopPropagation();
            e.preventDefault();
            handleSaveResponse({ value: response, prompt });
            setManualClose(true);
          }}
          type="submit"
          variant="filled"
        />
      </Flexbox>
    </>
  );
};

MultiSelectInput.propTypes = {
  contextId: number,
  handleDeleteResponse: func.isRequired,
  handleSaveResponse: func.isRequired,
  initialValue: string,
  prompt: shape({}).isRequired,
  responseId: number,
  setManualClose: func.isRequired,
};

MultiSelectInput.defaultProps = {
  contextId: undefined,
  initialValue: '',
  responseId: undefined,
};

export default MultiSelectInput;
